<template>
<b-tabs v-model="activeTab">
    <b-tab-item label="Information">
        <div class="column">
            <div class="column is-half">
                <b-field label="Search for userful info" class="">
                    <b-input v-model="usefulQuery"></b-input>
                    <b-button v-if="isManagement" @click="changeUsefulInfo(null)" type="is-success" style="margin-left:20px">Add new</b-button>
                </b-field>

            </div>
            <b-table :data="usefulInfo" :mobile-cards="true">
                <b-table-column field="title" label="Title" v-slot="props">
                    {{ props.row.title }}
                </b-table-column>

                <b-table-column field="title" label="URL" v-slot="props">
                    <b-button tag="a" :href="props.row.url" type="is-success" target="_blank" style="margin-right:20px">
                        View
                    </b-button>
                </b-table-column>

                <b-table-column field="actions" label="Actions" v-slot="props" width="260" v-if="isManagement">
                    <b-button tag="router-link" :to="'/add-uni/' + props.row.id" type="is-success" style="margin-right:20px">
                        Edit
                    </b-button>
                    <b-button @click="deleteUniversity(props.row.id)" type="is-danger" style="margin-right:20px">Delete</b-button>

                </b-table-column>

                <template #empty>
                    <div class="has-text-centered">No records</div>
                </template>
            </b-table>

            <b-modal v-model="showUsefulInfoModal" @close="resetModalData()">
                <div class="columns">
                    <b-field label="Title" class="column is-half">
                        <b-input v-model="usefulInfoElement.title" type="text" name="title"></b-input>
                    </b-field>

                    <b-field label="URL" class="column is-half">
                        <b-input v-model="usefulInfoElement.url" type="text" name="url"></b-input>
                    </b-field>

                    <b-button @click="submitInfo()" type="is-success" style="margin-left:15px">Submit</b-button>
                </div>
            </b-modal>
        </div>
    </b-tab-item>
    <b-tab-item label="Tutorials" class="tutorial-holder">
        <div class="tutorial-list">
            <div v-for="(tutorial, index) in tutorialData" :key="index" @click="setTutorial(tutorial.step)" :class="{'selected': videoTutorialStep === tutorial.step}">
                <b-icon icon="play-circle-outline" size="is-small" type="is-success"></b-icon>
                <span class="tutorial-title">{{ tutorial.title }}</span>
                <span class="video-duration">{{ tutorial.duration }}</span>
            </div>
        </div>

        <div class="tutorial-display" v-if="videoTutorialStep === currentTutorial.step">
            <video-player class="video-player-box" ref="videoPlayer" customEventName="customstatechangedeventname" :options="playerOptions" @ended="completedVideo = currentTutorial.step">
            </video-player>

            <div class="tutorial-display-text">
                <h5>{{ currentTutorial.title }}</h5>
                <span> Transcript </span>
                <p v-html="currentTutorial.transcript"></p>
            </div>
        </div>
    </b-tab-item>

</b-tabs>
</template>

<script>
require('videojs-youtube');
import UsefulInfoService from "../services/useful-info.service";
import UtilService from '../services/util'
import {
    tutorialData,
} from '../models/tutorial';
import {
    videoPlayer
} from 'vue-video-player'
import 'video.js/dist/video-js.css'

export default {
    name: "univeristy-list",
    components: {
        videoPlayer
    },
    data() {
        return {
            videoTutorialStep: 1,
            activeTab: 0,
            usefulInfo: [],
            tutorialData: [],
            usefulInfoCopy: [],
            usefulQuery: '',
            usefulInfoElement: {
                id: null,
                title: '',
                url: '',
                templateOptions: null
            },
            currentTutorial: {
                step: 0,
                image: '',
                title: '',
                transcript: ''
            },
            playerOptions: {
                // videojs options
                muted: false,
                language: 'en',
                fluid: true,
                playbackRates: [1],
                techOrder: ['youtube'],
                sources: [],
                poster: "",
                controls: true,
                autoplay: false,
            },
            showUsefulInfoModal: false
        };
    },
    created() {
        this.tutorialData = tutorialData;
        this.retrieveUsefulInfo();
    },
    watch: {
        'usefulQuery': {
            handler() {
                this.filterUniByText()
            },
            deep: true
        }
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        isManagement() {
            return UtilService.isManagement()
        },
    },
    methods: {
        retrieveUsefulInfo() {
            UsefulInfoService.getAll()
                .then(response => {
                    this.usefulInfo = response.data;
                    this.usefulInfoCopy = response.data
                })
        },

        filterUniByText() {
            this.usefulInfo = [...this.usefulInfoCopy].filter((option) => {
                return option.title
                    .toString()
                    .toLowerCase()
                    .indexOf(this.usefulQuery.toLowerCase()) >= 0 || option.url
                    .toString()
                    .toLowerCase()
                    .indexOf(this.usefulQuery.toLowerCase()) >= 0
            })
        },

        submitInfo() {
            if (this.usefulInfoElement.id) {
                UsefulInfoService.update(this.usefulInfoElement.id, this.usefulInfoElement).then(() => {
                    this.retrieveUsefulInfo()
                    this.resetModalData()
                })
            } else {
                UsefulInfoService.create(this.usefulInfoElement)
                    .then(() => {
                        this.usefulInfo.push(this.usefulInfoElement)
                        this.resetModalData()
                        this.$buefy.toast.open({
                            duration: 3000,
                            message: `University created succesfully`,
                            position: 'is-bottom',
                            type: 'is-success'
                        })
                    })
            }
        },

        resetModalData() {
            this.showUsefulInfoModal = false
            this.usefulInfoElement = {
                id: null,
                title: '',
                url: '',
                templateOptions: null
            }
        },

        changeUsefulInfo(type) {
            this.showUsefulInfoModal = true
            if (type) {
                this.usefulInfoElement = type
            }
        },

        submitUsefulInfo(type) {
            if (type) {
                this.usefulInfoElement = type
            }
        },

        deleteUniversity(id) {
            UsefulInfoService.delete(id)
                .then(() => {
                    const indexId = this.usefulInfo.indexOf(university => university.id === id)
                    this.usefulInfo.splice(indexId, 1)
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: `Info deleted`,
                        position: 'is-bottom',
                        type: 'is-success'
                    })
                })
        },

        setTutorial(step) {
            if (this.maxStepReached < step) {
                return
            }

            const foundTutorial = this.tutorialData.filter(tutorial => tutorial.step === step)
            if (foundTutorial.length) {
                this.playerOptions.sources = [
                    foundTutorial[0].video
                ]

                this.playerOptions.poster = foundTutorial[0].poster

                this.videoTutorialStep = foundTutorial[0].step

                this.currentTutorial = {
                    step: foundTutorial[0].step,
                    image: foundTutorial[0].image,
                    title: foundTutorial[0].title,
                    transcript: foundTutorial[0].transcript,
                }

            }
        },
    },

};
</script>

<style>
.uni-logo {
    max-width: 80px;
}

.tutorial-holder {
    display: flex;
}
</style>
